module.exports = __webpack_public_path__ + "components/media-kit/static/social-desktop-e023035fc73e58ecdb0641c3fdd30f03.png";